import { TeamReferenceStorySchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const TEAM_REFERENCE_STORY_TABLE = '"public"."teamReferenceStories"'

export const TeamReferenceStoryConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: TEAM_REFERENCE_STORY_TABLE,
  partitionKey: 'team_id',
  key: 'id',
  apiEndpoint: '/api/reference-stories',
  where: {},
  schema: TeamReferenceStorySchema,
}
